import { ModelFactory } from "../../ModelFactory";
import { parseItemPermissions, PermissionMap } from "../../common/models/PermissionMap";
import { Customer, customerFactory } from "../../common/models/Customer";
import { Contract, contractFactory } from "./Contract";
import { DeploymentStatus } from "../../common/models/DeploymentStatus";
import { DomainStatus } from "../../common/models/DomainStatus";

export class Domain {
  constructor(
    public readonly id: string,
    public readonly displayName: string,
    public readonly tld: string,
    public readonly notes: string | null,
    public readonly deploymentStatus: DeploymentStatus,
    public readonly createdAt: string,
    public readonly updatedAt: string,
    public readonly primaryContactId: string,
    public readonly administrativeContactId: string,
    public readonly technicalContactId: string,
    public readonly resellerContactId: string,
    public readonly customer: Customer | null,
    public readonly contracts: Contract[],
    public readonly externalDns: boolean,
    public readonly nameservers: string[],
    public readonly status: DomainStatus | null,
    public readonly isDnssecEnabled: boolean | null,
    public readonly dnssecKeys: { protocol: number, flags: number, alg: number, pub_key: string }[],
    public readonly isLockable: boolean,
    public readonly isLocked: boolean,
    public readonly permissions: PermissionMap | null,
  ) {
  }
}

class DomainFactory extends ModelFactory<Domain> {
  protected fromJson(json: any): Domain {
    return new Domain(
      json['id'],
      json['display_name'],
      json['tld'],
      json['notes'],
      json['deployment_status'],
      json['created_at'],
      json['updated_at'],
      json['domain_owner_id'],
      json['domain_admin_id'],
      json['domain_tech_id'],
      json['domain_reseller_id'],
      json['customer'] ? customerFactory.fromItemResponse(json['customer']) : null,
      json['contracts'] ? contractFactory.fromItemsResponse(json['contracts']) : [],
      json['external_dns'],
      json['nameservers'],
      json['status'] ?? null,
      json['is_dnssec_enabled'] ?? null,
      json['dnssec_keys'] ?? [],
      json['is_lockable'],
      json['is_locked'],
      parseItemPermissions(json['permissions']),
    );
  }
}
export const domainFactory = new DomainFactory();
